import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import styles from './HpSharedFeaturedItemsTitle.scss';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

type HpSharedFeaturedItemsTitleProps = {
    isMobile: boolean;
    isLoading?: boolean;
};

export const HpSharedFeaturedItemsTitle: FC<HpSharedFeaturedItemsTitleProps> = ({
    isMobile,
    isLoading,
}) => {
    return (
        <div
            className={classnames(
                isMobile
                    ? [dibsCss.sassyFontHeaderLarge, dibsCss.mtMedium, dibsCss.mbSmall]
                    : [
                          dibsCss.sassyFontHeaderXLarge,
                          dibsCss.mtLarger,
                          dibsCss.mbMedium,
                          dibsCss.textCenter,
                      ]
            )}
        >
            <span className={classnames(isLoading && styles.shimmer)}>
                <span className={classnames(isLoading && dibsCss.invisible)}>
                    <FormattedMessage
                        id="HpSharedFeaturedItemsCarousel.title"
                        defaultMessage="Featured Items <italic>For You</italic>"
                        values={{
                            italic: chunks => <em>{chunks}</em>,
                        }}
                    />
                </span>
            </span>
        </div>
    );
};
